/* ── Google Fonts ── */
const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href =
  "https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap";
if (!document.head.querySelector('[href*="DM+Sans"]'))
  document.head.appendChild(fontLink);

export const FONT_UI      = "'DM Sans', 'Segoe UI', sans-serif";
export const FONT_HEADING = "'DM Serif Display', Georgia, serif";

export const API_BASE_URL  = "https://patrol-react.eblackdog.net//api";
export const FALLBACK_LOGO = "../assets/image/eblackdog_logo.png";

export const SKIN_THEMES = [
  { id: "navy",    label: "Navy",    primary: "#1e3a5f", accent: "#2563eb", light: "#dbeafe", gradient: "linear-gradient(135deg,#1e3a5f 0%,#2563eb 100%)" },
  { id: "forest",  label: "Forest",  primary: "#14532d", accent: "#16a34a", light: "#dcfce7", gradient: "linear-gradient(135deg,#14532d 0%,#16a34a 100%)" },
  { id: "crimson", label: "Crimson", primary: "#7f1d1d", accent: "#dc2626", light: "#fee2e2", gradient: "linear-gradient(135deg,#7f1d1d 0%,#dc2626 100%)" },
  { id: "violet",  label: "Violet",  primary: "#3b0764", accent: "#7c3aed", light: "#ede9fe", gradient: "linear-gradient(135deg,#3b0764 0%,#7c3aed 100%)" },
  { id: "teal",    label: "Teal",    primary: "#134e4a", accent: "#0d9488", light: "#ccfbf1", gradient: "linear-gradient(135deg,#134e4a 0%,#0d9488 100%)" },
  { id: "amber",   label: "Amber",   primary: "#78350f", accent: "#d97706", light: "#fef3c7", gradient: "linear-gradient(135deg,#78350f 0%,#d97706 100%)" },
  { id: "slate",   label: "Slate",   primary: "#0f172a", accent: "#475569", light: "#e2e8f0", gradient: "linear-gradient(135deg,#0f172a 0%,#475569 100%)" },
  { id: "rose",    label: "Rose",    primary: "#881337", accent: "#e11d48", light: "#ffe4e6", gradient: "linear-gradient(135deg,#881337 0%,#e11d48 100%)" },
];